import React from "react"
import { Link } from "gatsby"

import Layout from "../../../components/layout"
import { FooterAlternate1 } from "../../../components/footer"
import SEO from "../../../components/seo"

const IndexPage = () => (
    <Layout>
      <SEO title="Personal relationships no longer matter in B2B Sales!" />

                      
<nav className="share-bar">
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/personal-relationships-no-longer-matter-b2b-sales/&amp;title=Personal%20relationships%20no%20longer%20matter%20in%20B2B%20Sales%21&amp;summary=Personal%20relationships%20no%20longer%20matter%20in%20B2B%20Sales%21&amp;source=https%3A//salestribe.com/knowledge-centre/insights/personal-relationships-no-longer-matter-b2b-sales/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-linkedin-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Personal%20relationships%20no%20longer%20matter%20in%20B2B%20Sales%21&amp;url=https%3A//salestribe.com/knowledge-centre/insights/personal-relationships-no-longer-matter-b2b-sales/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-twitter-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/personal-relationships-no-longer-matter-b2b-sales/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon">
                    <svg width="26" height="26">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-googleplus-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/personal-relationships-no-longer-matter-b2b-sales/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon">
                    <svg width="22" height="22">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-facebook-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Personal%20relationships%20no%20longer%20matter%20in%20B2B%20Sales%21&amp;body=https%3A//salestribe.com/knowledge-centre/insights/personal-relationships-no-longer-matter-b2b-sales/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon">
                    <svg width="20" height="20">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-email-badge"></use>
                    </svg>
                </span>
            </Link>
        </li>
    </ul>
</nav>

<article className="article">

    

<header className="header header--article article__header" id="page-header">
    <div className="header__image" >
        <div className="header__bgimage" style={{backgroundImage: "url(../../../media/images/article-success-hole-jump.2e16d0ba.fill-1162x655.jpg)"}}></div>
        <div className="header__video">
            <div className="embed-responsive embed-responsive-16by9"></div>
        </div>
    </div>
    <div className="header__content">
        <div className="container">
            <div className="row">
                <div className="header__inner col-md-7 col-lg-offset-1">
                    <Link to="knowledge-centre/insights/" className="header__back back-link">
                        <span className="sr-only">Back to all articles</span>
                        <i className="icon"></i>
                    </Link>
                    <div className="header__title">
                        <h3>B2B Sales</h3>
                        <h1>Personal relationships no longer matter in B2B Sales!</h1>
                    </div>
                    <ul className="post-meta-list">
                        <li>by Graham Hawkins</li>
                        <li>16 August 2016</li>
                        <li>5 min read</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</header>


<div className="container" id="article-content">
    <div className="row">
        <div className="article__body col-sm-12 col-md-8 col-lg-offset-1 col-lg-7 wysiwyg">
            
<h3>People buy from people right? Really?</h3>
<p>I can almost feel the sales world bristling at my controversial headline, and whilst it sounds totally counter-intuitive (even to me), I ask that you please read this post with an open mind, and please consider some of the facts that are now emerging to impact the sales profession.</p>
<div className="rich-text"><p>For centuries, sales people have placed a very high level of importance on the “personal relationships” elements of selling, and that buyers need to <em>trust</em> the sales person that they are dealing with. In almost 3 decades of selling I have constantly been taught that <em><strong>“people buy from people” </strong></em>however, like so many aspects of the legacy B2B sales approach, this old concept is now disappearing with the new customer-led era.</p><p><strong>CONSENSUS BUYING: </strong>Gone are the days of having any kind of lasting relationship with your B2B buyer that’s strong enough to truly influence buyer decision making, especially since we now increasingly see consensus decision making. CEB research indicates that <em>“there is on average 6.8 decision makers involved in every buying decision”,</em> meaning that the old days of simply finding the single ‘decision maker’ are long past. And, please don’t try to argue that you can develop meaningful relationships with 6.8 individuals – many of whom are cross functional and from different regions, all with their own (and often conflicting) agenda.</p><p><strong>AVOIDING THE SALES PERSON: </strong>People now increasingly buy from machines and websites, meaning that we sales folks need to stop thinking that our ‘personal relationship’ (which is actually an oxymoron in a B2B context anyway) means as much as it once did. Buyers, across practically every industry, segment, category and region are now demonstrating that they prefer to bypass the sales person every chance they get. Why? Primarily, because every single buyer on the planet knows that each and every sales person has a vested interest in trying to convince the buyer to purchase <em>their</em>product regardless of whether it’s the right fit for their problem. Buyers are all very well acquainted with the dichotomous game that we all play, where buyers always chase decreasing costs, whilst vendors push for increasing revenue, and nothing has changed there. What has changed is that buyers are no longer willing to engage in that game, and when they do, it’s now on their terms. Buyer now hold the power and we sales people are on the back foot.</p></div>
<aside className="pull-quote">
    <blockquote>
        <p>“93% of B2B buyers say that they prefer to buy online rather than from a salesperson when they’ve decided what to buy and just need to make the purchase” - Forrester Research.</p>
    </blockquote>
</aside>

<div className="rich-text"><p>Buyers have evolved but sales people have not. B2B buyers no longer need a 'personal relationship' with you in order to make a decision. They will NOT stick with you just because you are a good person – trusted, likeable and dependable. If you don’t believe me, then go and tell your important buyer that you have just put your prices up by 10% and see what happens. Let’s see how long you’re so called ‘customer relationship’ lasts when your buyer is forced to go to his/her management and argue for more budget due to your unilateral price increase. Let’s see how strong your relationship is when a new low cost substitute product comes along offering 5-10% savings for similar output. This has happened to me many times, and trust me when I say that your customer will rarely say “<em>it’s OK, we’re sticking with you because we really value our personal relationship with you</em>”.</p><p><strong>SALES STAFF TURNOVER: </strong>Against this backdrop, buyers are also aware that their current sales person will likely be gone and replaced by someone new very soon. The average tenure of a sales person is now said to be as low as <strong>1.4 years</strong> and for this reason buyers now place very little value in the concept of a 'personal 'relationship'. Customers often lament the fact that they have had to endure a revolving door of account managers. Sound familiar?</p><p>Its my belief that the "relationship" is increasingly with your business, not you personally. Buyers are now very risk averse, and primarily need to know that your company is a "safe pair of hands". Buyers know that when push comes to shove that you are just the sales person....it's your company that has to deliver. Remember that enterprise level buyers are often dealing with thousands of vendors, and that means that many now have more ‘relationships’ than they can possibly manage effectively anyway. Yes, if you are a Tier 1 vendor or a vendor of some “strategic importance” then you might be able to lay claim to having an important relationship with the buyer, but even then I will argue that your buyer will ditch you quick smart the moment they can get a better deal elsewhere. Throughout my career I have witnessed this happen time and again, and it’s always a good wake up call. As Michael Corleone said in the Godfather movie – <em>“it’s not personal Sonny, it’s strictly business”.</em></p><p><strong>DIGITAL ENGAGEMENT: </strong>Yes, there are some instances when buyers still prefer to interact with a sales person, but when they do, it’s increasingly via digital means like email, chat, sales engagement platforms, Skype and collaborative software rather than F2F or via phone calls. What does this tell you? It tells me that a warm and fuzzy 'personal relationship' is no longer as important to buyers as we sales people might think…..buyers simply don't need it, and don’t have time for it. Hence the rise and rise of companies like InsideSales.com, and the increasing job ads for Sales Development Reps (SDR's) and inside sales roles.</p><p>I can already hear some of you railing against my assertions by saying, <em>“not in my industry – people still buy from people”</em>. The facts now prove that <em><strong>“groups of people buy from businesses”,</strong></em> and most buyers prefer to bypass the sales person (whom is often seen as an order taker) whenever they can by self-serving and purchasing online. Thus, your so called 'personal relationship' with the buyer is no longer worth what you think its worth. Buyers place their trust in your company’s ability to deliver….safe in the knowledge that you (personally) could be gone tomorrow anyway.<br/></p><p>So, if you are currently in a B2B sales role, then start engaging your customers the way that they want to be engaged – <em>digitally</em>. Cease and desist with the long-winded fluffy stuff, and start treating your buyers as a part of a group 6.8 professional business people whom are all driven the same way you are – with KPI’s and financial metrics that are all designed to improve shareholder value. Certainly do NOT rely solely on your 'relationship' to win the deal.</p></div>


        </div>
            
        <aside className="article__sidebar col-sm-12 col-md-4 col-lg-offset-1 col-lg-3">
            <div className="article__sidebar-wrap" id="article-sidebar">
                <div className="card card--profile">
                        
<div className="card__header">
    <div className="card__image">
        <img alt="Mentor Thumb Graham Hawkins" className="img-responsive" height="165" src="../../../media/images/Mentor-Thumb-Graham-Hawkins.2e16d0ba.fill-165x165.jpg" width="165"/>
    </div>
    <div className="card__title">
        <h4>Graham Hawkins</h4>
        <p>SalesTribe Mentor</p>
        <Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-md hidden-lg">View full profile</Link>
    </div>
</div>
<div className="rich-text"><p>With more than twenty-eight years of business experience in
executive B2B sales and sales leadership roles, Graham is a highly experienced
and versatile business executive with proven strengths in strategic business
development, go-to-market planning and sales and marketing.</p><p><br/></p><p><br/></p></div>
<Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-xs hidden-sm">View full profile</Link>

                </div>
                <nav className="social-nav">
    <h4>Share</h4>
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/personal-relationships-no-longer-matter-b2b-sales/&amp;title=Personal%20relationships%20no%20longer%20matter%20in%20B2B%20Sales%21&amp;summary=Personal%20relationships%20no%20longer%20matter%20in%20B2B%20Sales%21&amp;source=https%3A//salestribe.com/knowledge-centre/insights/personal-relationships-no-longer-matter-b2b-sales/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon icon-linkedin"></span>
                
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Personal%20relationships%20no%20longer%20matter%20in%20B2B%20Sales%21&amp;url=https%3A//salestribe.com/knowledge-centre/insights/personal-relationships-no-longer-matter-b2b-sales/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon icon-twitter"></span>
                
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/personal-relationships-no-longer-matter-b2b-sales/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon icon-google-plus"></span>
                
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/personal-relationships-no-longer-matter-b2b-sales/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon icon-facebook-f"></span>
                
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Personal%20relationships%20no%20longer%20matter%20in%20B2B%20Sales%21&amp;body=https%3A//salestribe.com/knowledge-centre/insights/personal-relationships-no-longer-matter-b2b-sales/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon icon-envelope"></span>
                
            </Link>
        </li>
    </ul>
</nav>

            </div>
        </aside>
            
    </div>
</div>
</article>

<div className="block block--grey related-items">
    <div className="related-items__wrap">
        <div className="container">
            <div className="row" data-tablet-slick>
                
        <article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-complete-waste-money-and-time-part-2" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">5 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>Sales Training’ is a waste of money and time (Part 2)</strong></h3>
                    </header>
                    <p>We must stop teaching sales people how to ‘push’ buyers, and instead start training and coaching them on how to become highly specialised teachers.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-waste-time-and-money-part-1" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">4 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>‘Sales Training’ is a waste of time and money (Part 1)</strong></h3>
                    </header>
                    <p>When you teach sales people how to ‘push’ buyers through a sales playbook you are teaching them how to destroy your business reputation.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/b2b-sales-has-changed-about-180-degrees" className="card card--article">
                <div className="card__thumb">
                    <img alt="Mentor Large Graham Hawkins" className="card__image" height="404" src="../../../media/images/Mentor-Large-Graham-Hawkins.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">04:28</span>
                    <span className="card__icon play-icon">
                        <i className="icon"></i>
                    </span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>B2B Sales has changed about 180 Degrees!</strong></h3>
                    </header>
                    <p>B2B sales has now changed so dramatically that it&#39;s a &quot;profession&quot; that is barely recognisable to the role that both Tony Hughes and Graham Hawkins began about 30 years ago - respectively.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article>

            </div>
            <div className="load-more">
                <Link to="knowledge-centre/insights/" className="btn btn-link">Browse more insights</Link>
            </div>
        </div>
    </div>
</div>

      
      <FooterAlternate1 />

    </Layout>
)

export default IndexPage 